export default __webpack_public_path__ + "static/media/1.a6f0ce4d.jpg";